/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { Box } from '@chakra-ui/react'
import { css } from '@emotion/react'
import { GiRibbonMedal } from 'react-icons/gi'
import { jsx } from 'theme-ui'
import BottomSection from './WhyUs.styles'
import { Col, FlexGrid, Heading, Html, Text } from '../../components/elements'
import { Family, Ribbon, Tools, Shield, Communication } from '../../customIcons'

const WhyUs = ({ bottomSection, sectionTitle, headerText, mainText, reasons }) => {
  return (
    <>
      <Col maxWidth={600} mx="auto" mt={[2, 3, 4]}>
        <Heading my={0} color="primary" sx={{ fontSize: [4, 5] }}>
          {sectionTitle}
        </Heading>
        <Heading sx={{ fontSize: [5, 6] }}>{headerText} </Heading>
        <Html
          html={mainText}
          sx={{
            mt: 3,
            px: 3,
            p: {
              fontSize: [18, 18, 24],
            },
            fontWeight: 500,
          }}
          fontWeight="bold"
        />
      </Col>
      <FlexGrid
        mx="auto"
        sx={{
          maxWidth: ['95%', '95%', 900, 1100],
          justifyContent: 'space-evenly',
        }}
        textAlign="center"
        my={[3, 4]}
        overflow="auto"
      >
        {reasons.map((reason, i) => {
          return (
            <Box
              key={i}
              sx={{
                width: ['50%', '50%', '30%', '15%'],
                position: 'relative',
                mb: [2, 3, 4],
                mt: [2, 2, 3],
              }}
              py={2}
              px={2}
              as={Col}
              _hover={{
                boxShadow: '2px 4px 8px 2px rgba(0,0,0,0.35)',
                background: 'white !important',
              }}
            >
              {reason.icon === 'family' ? (
                <Family
                  sx={{
                    svg: {},
                    p: [4, 4, 1],
                    width: '100%',
                    height: '100%',
                    color: 'primary',
                  }}
                />
              ) : reason.icon === 'ribbon' ? (
                <Ribbon
                  sx={{
                    svg: {},
                    p: [4, 4, 1],
                    width: '100%',
                    height: '100%',
                    color: 'primary',
                  }}
                />
              ) : reason.icon === 'tools' ? (
                <Tools
                  sx={{
                    svg: {},
                    p: [4, 4, 1],
                    width: '100%',
                    height: '100%',
                    color: 'primary',
                  }}
                />
              ) : reason.icon === 'shield' ? (
                <Shield
                  sx={{
                    svg: {},
                    p: [4, 4, 1],
                    width: '100%',
                    height: '100%',
                    color: 'primary',
                  }}
                />
              ) : reason.icon === 'communication' ? (
                <Communication
                  sx={{
                    svg: {},
                    p: [4, 4, 1],
                    width: '100%',
                    height: '100%',
                    color: 'primary',
                  }}
                />
              ) : (
                <GiRibbonMedal
                  sx={{
                    svg: {},
                    p: [4, 4, 1],
                    width: '100%',
                    height: '100%',
                    color: 'primary',
                  }}
                />
              )}
              <Text
                sx={{
                  fontSize: [18, 18, 23],
                  mt: [2, 3],
                  maxWidth: 150,
                  fontWeight: 700,
                  color: '#363636',
                  textAlign: 'center',
                }}
              >
                {reason.text}
              </Text>
            </Box>
          )
        })}
      </FlexGrid>

      <div
        css={css`
          margin-top: 10%;
        `}
      >
        <BottomSection sx={{ mt: '-15%' }} {...bottomSection} />
      </div>
    </>
  )
}

export default WhyUs
